/* ═══════════ SHOPIFY FIXES ═══════════ */
(function(){
  var IMG_URL='https://cdn.shopify.com/s/files/1/0965/9813/1028/files/image.png?v=1781188916';

  var h=document.querySelector('#shopify-section-header,[id^="shopify-section-header"],[id^="shopify-section-sections--"][id*="header"]');
  if(!h){
    var secs=document.querySelectorAll('[id^="shopify-section"]');
    for(var i=0;i<secs.length;i++){
      if(secs[i].querySelector('header,nav,.header-wrapper,.header__wrapper,.header__heading')){h=secs[i];break}
    }
  }
  if(h){h.style.position='relative';h.style.zIndex='10001'}
  var ab=document.querySelector('[id^="shopify-section"][id*="announcement"],[id^="shopify-section-sections--"][id*="announcement"]');
  if(ab){ab.style.position='relative';ab.style.zIndex='10002'}

  var bgfx=document.getElementById('bgfx');
  if(bgfx&&bgfx.parentElement!==document.body){document.body.insertBefore(bgfx,document.body.firstChild)}
  var ld=document.getElementById('ld');
  if(ld&&ld.parentElement!==document.body){document.body.insertBefore(ld,bgfx?bgfx.nextSibling:document.body.firstChild)}

  var portal=document.getElementById('portal');
  if(portal&&portal.parentElement!==document.body){document.body.appendChild(portal)}
  var pop=document.getElementById('pop');
  if(pop&&pop.parentElement!==document.body){document.body.appendChild(pop)}

  var bg=document.getElementById('bg-img');
  if(bg){
    if(!bg.src||bg.src==='')bg.src=IMG_URL;
    bg.style.position='absolute';bg.style.inset='-4%';bg.style.objectFit='cover';
    bg.style.filter='brightness(.6) saturate(1.06)';bg.style.width='108%';bg.style.height='108%';bg.style.display='block';
  }

  var root=document.getElementById('amk300k-root');
  var sec=root?root.closest('.shopify-section,[id^="shopify-section"]'):document.querySelector('.amk-300k-section');
  if(sec){
    sec.style.cssText+=';position:relative!important;z-index:1!important;background:transparent!important;overflow:visible!important;contain:none!important;transform:none!important;will-change:auto!important;filter:none!important;perspective:none!important;backdrop-filter:none!important;isolation:auto!important';
    var el=sec.parentElement;
    while(el&&el!==document.body&&el!==document.documentElement){
      el.style.background='transparent';el.style.backgroundColor='transparent';
      el.style.contain='none';el.style.transform='none';el.style.filter='none';
      el.style.isolation='auto';el.style.perspective='none';
      el=el.parentElement;
    }
  }

  document.body.style.background="#070303 url('"+IMG_URL+"') center/cover fixed no-repeat";
})();

/* ═══════════ API ═══════════ */
var API='https://cbwxgikndyyzdslmfpmo.supabase.co/functions/v1/giveaway';
var ANON='eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNid3hnaWtuZHl5emRzbG1mcG1vIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzc4MzYzNTcsImV4cCI6MjA5MzQxMjM1N30.zvKKQ7sN6hhMRmwaJVYmjI0cgZDktyXnTb7iYWL4ZPI';
var GVH={'Content-Type':'application/json','Authorization':'Bearer '+ANON,'apikey':ANON};
function vEmail(e){return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(e||'').trim())}

/* ═══════════ BOOST-BANNER: sichtbar oder nicht ═══════════
   Die Boost-Szene (Banner + Text) darf nur stehen, wenn die Zentrale es
   erlaubt — bei Modus „live" heißt das: nur solange der Boost wirklich läuft.
   Bis die Antwort da ist, bleibt sie aus. Lieber ein Durchlauf ohne Boost
   als ein Boost-Banner, das gar nicht gilt.                              */
window.BOOST_BANNER = null;          // null = noch unbekannt
var _boostBannerWartende = [];
function beiBoostBanner(fn){ if(window.BOOST_BANNER!==null) fn(window.BOOST_BANNER); else _boostBannerWartende.push(fn); }
function setzeBoostBanner(d){
  if(window.BOOST_BANNER!==null) return;
  window.BOOST_STATUS_ROH = d || null;
  // banner_visible liefert die neue Edge Function; ältere kennt nur show_banner.
  var sichtbar = d ? (typeof d.banner_visible==='boolean' ? d.banner_visible : d.show_banner!==false) : false;
  // Ticket-Eingabe in der Zentrale gesperrt (Giveaway → Ticket-Boost → Ticket-Eingabe):
  // Formular zu, kein Boost-Banner — die Edge Function lehnt Einträge ohnehin ab.
  window.TICKETS_GESPERRT = !!(d && d.entries_open===false);
  window.TICKETS_SPERRTEXT = (d && d.entries_note) || 'Die Ticket-Eingabe ist geschlossen. Es können keine neuen Einzahlungen mehr eingetragen werden.';
  if(window.TICKETS_GESPERRT){ sichtbar=false; if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', sperreTicketEingabe); else sperreTicketEingabe(); }
  window.BOOST_BANNER = { sichtbar: sichtbar, url: (d&&d.banner_url)||'', mult: (d&&d.multiplier)||20,
                          aktiv: !!(d&&d.active), casinos: (d&&d.active_casinos)||[] };
  _boostBannerWartende.splice(0).forEach(function(fn){ try{ fn(window.BOOST_BANNER) }catch(e){} });
}
function sperreTicketEingabe(){
  var f=document.getElementById('sf'); if(!f) return;
  Array.prototype.forEach.call(f.querySelectorAll('input,select,button[type="submit"]'),function(el){ el.disabled=true; });
  pmsg('s-msg', window.TICKETS_SPERRTEXT, 'err');
}
// Status sofort holen — parallel zum Laden der Bühne.
(function(){
  var fertig=false;
  // Notbremse: die Bühne wartet auf diese Antwort, also darf sie nie lange
  // ausbleiben. Nach 1,5s läuft die Seite ohne Boost-Szene weiter.
  var stop=setTimeout(function(){ if(!fertig) setzeBoostBanner(null); }, 1500);
  fetch(API,{method:'POST',headers:GVH,body:JSON.stringify({action:'boost_status'})})
    .then(function(r){return r.json().catch(function(){return{}})})
    .then(function(d){ fertig=true; clearTimeout(stop); setzeBoostBanner(d&&d.status==='success'?d:null); })
    .catch(function(){ fertig=true; clearTimeout(stop); setzeBoostBanner(null); });
})();

/* ═══════════ 3D SCROLL STAGE ═══════════ */
function initStage(){
  if(typeof gsap==='undefined')return;
  gsap.registerPlugin(ScrollTrigger);
  var banner=document.getElementById('l-banner'),heli=document.getElementById('l-heli'),boeing=document.getElementById('l-boeing'),
      jet=document.getElementById('l-jet'),bus=document.getElementById('l-bus'),ticket=document.getElementById('l-ticket'),
      boost=document.getElementById('l-boost'),
      smoke=document.getElementById('heli-smoke'),trail=document.getElementById('jet-trail');

  var mob=window.innerWidth<680;
  gsap.set(banner,{xPercent:-50,yPercent:-50,x:'0vw',  y:mob?'-12vh':'-4vh', scale:mob?.88:1.05,opacity:1,rotation:0,z:0});
  gsap.set(boeing,{xPercent:-50,yPercent:-50,x:mob?'0vw':'2vw',  y:mob?'-32vh':'-26vh',scale:mob?.38:.68,opacity:1,rotation:-3});
  gsap.set(jet,   {xPercent:-50,yPercent:-50,x:mob?'26vw':'32vw', y:mob?'-16vh':'-12vh',scale:mob?.3:.52,opacity:1,rotation:10});
  gsap.set(heli,  {xPercent:-50,yPercent:-50,x:mob?'-26vw':'-34vw',y:mob?'-10vh':'-4vh', scale:mob?.36:.58, opacity:1,rotation:-8});
  gsap.set(bus,   {xPercent:-50,yPercent:-50,x:'-5vw', y:'20vh', scale:.36,opacity:0,rotation:0});
  gsap.set(ticket,{xPercent:-50,yPercent:-50,x:'34vw', y:'18vh', scale:.34,opacity:0,rotation:7});
  gsap.set(boost, {xPercent:-50,yPercent:-50,x:'0vw',  y:'16vh', scale:.34,opacity:0,rotation:-6});

  var scr=mob?0.8:1.2;
  if(mob){
    gsap.fromTo('#bg-img',{scale:1.0,filter:'brightness(.55) saturate(1.08)'},
      {scale:1.08,filter:'brightness(.2) saturate(.95)',ease:'none',
       scrollTrigger:{trigger:'body',start:'top top',end:'bottom bottom',scrub:scr}});
  }else{
    gsap.fromTo('#bg-img',{scale:1.0,filter:'brightness(.55) saturate(1.08) blur(0px)'},
      {scale:1.16,filter:'brightness(.16) saturate(.95) blur(7px)',ease:'none',
       scrollTrigger:{trigger:'body',start:'top top',end:'bottom bottom',scrub:scr}});
  }
  gsap.fromTo('#bg-veil',{opacity:.35},{opacity:.92,ease:'none',scrollTrigger:{trigger:'body',start:'top top',end:'60% bottom',scrub:scr}});

  var tl=gsap.timeline({scrollTrigger:{trigger:'#stage',start:'top top',end:mob?'+=4600':'+=6500',pin:true,scrub:mob?0.8:1.2,anticipatePin:1}});

  /* A1 */
  tl.addLabel('a1')
    .to('#hero-panel',{opacity:0,y:-30,scale:.92,duration:.3,ease:'power2.in'},'a1')
    .to('#stage-scroll',{opacity:0,duration:.2},'a1')
    .to(banner,{y:'-46vh',scale:.32,opacity:.35,duration:1,ease:'power2.inOut'},'a1')
    .to([boeing,jet,bus,ticket],{y:'-130vh',opacity:0,scale:.2,duration:.9,stagger:.04,ease:'power2.in'},'a1')
    .fromTo(heli,{x:mob?'-26vw':'-34vw',y:mob?'-10vh':'-4vh',scale:mob?.36:.58,rotation:-8,opacity:1},{x:'0vw',y:mob?'-14vh':'-2vh',scale:mob?.8:1,rotation:0,opacity:1,duration:1.1,ease:'expo.out'},'a1')
    .to(heli,{y:'+=2vh',duration:.5,ease:'sine.inOut'},'a1+=1.0')
    .to(smoke,{opacity:1,scale:1.08,duration:.7,ease:'power1.out'},'a1+=.35')
    .fromTo('#cap-1',{opacity:0,y:60,filter:mob?'none':'blur(6px)'},{opacity:1,y:0,filter:'none',duration:.55,ease:'power3.out'},'a1+=.65');

  /* A2 */
  tl.addLabel('a2','+=.6')
    .to('#cap-1',{opacity:0,y:-46,filter:mob?'none':'blur(6px)',duration:.4,ease:'power2.in'},'a2')
    .to(smoke,{opacity:0,duration:.4},'a2')
    .to(heli,{y:'-105vh',scale:1.2,opacity:0,rotation:12,duration:1,ease:'power3.in'},'a2')
    .fromTo(boeing,{x:'-120vw',y:'4vh',scale:.85,rotation:-12,opacity:0},{x:'0vw',y:mob?'-14vh':'-6vh',scale:mob?.72:.88,rotation:0,opacity:1,duration:1.15,ease:'expo.out',immediateRender:false},'a2+=.15')
    .to(boeing,{rotation:2,duration:.5,ease:'sine.inOut'},'a2+=1.2').to(boeing,{rotation:0,duration:.5,ease:'sine.inOut'},'a2+=1.7')
    .fromTo('#cap-2',{opacity:0,y:60,filter:mob?'none':'blur(6px)'},{opacity:1,y:0,filter:'none',duration:.55,ease:'power3.out'},'a2+=.8');

  /* A3 */
  tl.addLabel('a3','+=.6')
    .to('#cap-2',{opacity:0,y:-46,filter:mob?'none':'blur(6px)',duration:.4,ease:'power2.in'},'a3')
    .to(boeing,{x:'115vw',y:'-30vh',scale:1.4,rotation:16,opacity:0,duration:.95,ease:'power3.in'},'a3')
    .set(trail,{opacity:0},'a3')
    .fromTo(jet,{x:'110vw',y:'80vh',scale:.42,rotation:20,opacity:0},{x:mob?'0vw':'-4vw',y:mob?'-14vh':'-2vh',scale:mob?.85:1.06,rotation:-10,opacity:1,duration:.95,ease:'expo.out',immediateRender:false},'a3+=.15')
    .to(trail,{opacity:.8,duration:.35},'a3+=.2').to(trail,{opacity:0,duration:.5},'a3+=.7')
    .to(jet,{x:'0vw',y:mob?'-12vh':'1vh',rotation:-2,scale:mob?.82:1.02,duration:.6,ease:'back.out(1.4)'},'a3+=.95')
    .fromTo('#cap-3',{opacity:0,y:60,filter:mob?'none':'blur(6px)'},{opacity:1,y:0,filter:'none',duration:.55,ease:'power3.out'},'a3+=1.0');

  /* A4 */
  tl.addLabel('a4','+=.6')
    .to('#cap-3',{opacity:0,y:-46,filter:mob?'none':'blur(6px)',duration:.4,ease:'power2.in'},'a4')
    .to(jet,{x:'-30vw',y:'-26vh',scale:1.2,rotation:10,opacity:0,duration:.85,ease:'power3.in'},'a4')
    .fromTo(bus,{x:'120vw',y:'6vh',scale:.7,opacity:0},{x:'0vw',y:mob?'-12vh':'2vh',scale:mob?.82:1.04,opacity:1,duration:1.05,ease:'expo.out',immediateRender:false},'a4+=.15')
    .fromTo('#cap-4',{opacity:0,y:60,filter:mob?'none':'blur(6px)'},{opacity:1,y:0,filter:'none',duration:.55,ease:'power3.out'},'a4+=.7');

  /* A5 */
  tl.addLabel('a5','+=.6')
    .to('#cap-4',{opacity:0,y:-46,filter:mob?'none':'blur(6px)',duration:.4,ease:'power2.in'},'a5')
    .to(bus,{x:'-120vw',y:'4vh',scale:.8,opacity:0,duration:.9,ease:'power3.in'},'a5')
    .fromTo(ticket,{x:'0vw',scale:.3,y:'4vh',opacity:0,rotation:-12},{x:'0vw',scale:mob?.85:1,y:mob?'-16vh':'-6vh',opacity:1,rotation:0,duration:.9,ease:'back.out(1.6)',immediateRender:false},'a5+=.15')
    .to(ticket,{rotation:4,duration:.5,ease:'sine.inOut'},'a5+=1.05').to(ticket,{rotation:0,duration:.5,ease:'sine.inOut'},'a5+=1.55')
    .fromTo('#cap-5',{opacity:0,y:60,filter:mob?'none':'blur(6px)'},{opacity:1,y:0,filter:'none',duration:.55,ease:'power3.out'},'a5+=.5');

  /* A6 — 20X TICKET BOOST (letzte Szene; entfällt komplett, wenn das Banner aus ist) */
  var zeigeBoost = !!(window.BOOST_BANNER && window.BOOST_BANNER.sichtbar);
  if(zeigeBoost){
    if(window.BOOST_BANNER.url && boost) boost.setAttribute('src', window.BOOST_BANNER.url);
    tl.addLabel('a6','+=.6')
      .to('#cap-5',{opacity:0,y:-46,filter:mob?'none':'blur(6px)',duration:.4,ease:'power2.in'},'a6')
      .to(ticket,{y:'-105vh',scale:1.2,opacity:0,rotation:-10,duration:.9,ease:'power3.in'},'a6')
      .fromTo(boost,{x:'0vw',y:'22vh',scale:.34,opacity:0,rotation:-6},{x:'0vw',y:mob?'-14vh':'-4vh',scale:mob?.9:1.08,opacity:1,rotation:0,duration:1.05,ease:'expo.out',immediateRender:false},'a6+=.15')
      .to(boost,{scale:mob?.94:1.13,duration:.6,ease:'sine.inOut'},'a6+=1.15').to(boost,{scale:mob?.9:1.08,duration:.6,ease:'sine.inOut'},'a6+=1.75')
      .fromTo('#cap-6',{opacity:0,y:60,filter:mob?'none':'blur(6px)'},{opacity:1,y:0,filter:'none',duration:.55,ease:'power3.out'},'a6+=.7');
  }else{
    // Szene raus: Bild und Text verschwinden, cap-5 bleibt die letzte Station.
    if(boost) boost.style.display='none';
    var c6=document.getElementById('cap-6'); if(c6) c6.style.display='none';
  }

  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){e.target.classList.add('vis');io.unobserve(e.target)}})},{threshold:.1,rootMargin:'0px 0px -8% 0px'});
    document.querySelectorAll('.rv').forEach(function(el){io.observe(el)});
  }else document.querySelectorAll('.rv').forEach(function(el){el.classList.add('vis')});

  var imgs=document.querySelectorAll('#stage img');var L=0;
  imgs.forEach(function(im){if(im.complete)L++;else im.addEventListener('load',function(){L++;if(L>=imgs.length)ScrollTrigger.refresh()})});
  ScrollTrigger.refresh();
}
var _staged=false;
function bootStage(){
  if(_staged)return;
  // Erst wenn feststeht, ob die Boost-Szene mitspielt — sonst müsste die
  // Timeline nachträglich umgebaut werden. Die Notbremse oben sorgt dafür,
  // dass das nie länger als 1,5s dauert.
  if(window.BOOST_BANNER===null){ beiBoostBanner(bootStage); return; }
  _staged=true;try{initStage()}catch(e){console.error(e)}
}
function hideLoader(){var l=document.getElementById('ld');if(l)l.classList.add('out')}
if(document.readyState!=='loading')bootStage();else document.addEventListener('DOMContentLoaded',bootStage);
window.addEventListener('load',function(){bootStage();if(typeof ScrollTrigger!=='undefined')ScrollTrigger.refresh();setTimeout(hideLoader,1800)});
setTimeout(hideLoader,3200);

/* ═══════════ COUNTDOWN (zum Giveaway-Ende: Di 15.09.2026, 23:59 Uhr Berlin) ═══════════
   Stand 14.09.: stand auf dem 14.09. — Marcel: „das muss morgen sein". Mit Zeitzone, damit es
   fuer jeden Besucher 23:59 deutscher Zeit ist, egal wo er sitzt. */
(function(){
  var END=new Date('2026-09-15T23:59:00+02:00');
  var d=document.getElementById('cd-d'),h=document.getElementById('cd-h'),mi=document.getElementById('cd-m'),s=document.getElementById('cd-s'),lsDays=document.getElementById('ls-days');
  function pad(n){return (n<10?'0':'')+n}
  function tick(){var diff=END-new Date();if(diff<0)diff=0;
    var days=Math.floor(diff/864e5),hrs=Math.floor(diff%864e5/36e5),mins=Math.floor(diff%36e5/6e4),secs=Math.floor(diff%6e4/1e3);
    if(d)d.textContent=pad(days);if(h)h.textContent=pad(hrs);if(mi)mi.textContent=pad(mins);if(s)s.textContent=pad(secs);if(lsDays)lsDays.textContent=days}
  tick();setInterval(tick,1000);
})();

/* ═══════════ LIVE STATS count-up ═══════════ */
(function(){
  var els=document.querySelectorAll('.stat-num[data-count]');if(!els.length||!('IntersectionObserver' in window))return;
  var io=new IntersectionObserver(function(ents){ents.forEach(function(e){if(!e.isIntersecting)return;io.unobserve(e.target);
    var el=e.target,target=+el.getAttribute('data-count'),suf=el.getAttribute('data-suffix')||'',st=performance.now(),dur=1600;
    requestAnimationFrame(function f(n){var p=Math.min((n-st)/dur,1),ease=1-Math.pow(1-p,3);el.textContent=Math.floor(ease*target).toLocaleString('de-DE')+suf;if(p<1)requestAnimationFrame(f);else el.textContent=target.toLocaleString('de-DE')+suf})
  })},{threshold:.4});
  els.forEach(function(el){io.observe(el)});
})();

/* ═══════════ LIVE TEILNEHMERZAHL (echte Zahl aus der API) ═══════════ */
function amkCountUp(el,target){
  if(!el)return;target=parseInt(target,10)||0;
  if(!('requestAnimationFrame' in window)){el.textContent=target.toLocaleString('de-DE');return}
  var st=performance.now(),dur=1400;
  requestAnimationFrame(function f(n){var p=Math.min((n-st)/dur,1),e=1-Math.pow(1-p,3);
    el.textContent=Math.floor(e*target).toLocaleString('de-DE');
    if(p<1)requestAnimationFrame(f);else el.textContent=target.toLocaleString('de-DE')})
}
(function(){
  var el=document.getElementById('ls-participants');if(!el)return;
  fetch(API,{method:'POST',headers:GVH,body:JSON.stringify({action:'stats'})})
    .then(function(r){return r.json().catch(function(){return{}})})
    .then(function(d){
      if(!d||d.status!=='success')return; // stats noch nicht deployt -> Platzhalter bleibt
      var n=(typeof d.participants==='number')?d.participants:(typeof d.userCount==='number'?d.userCount:null);
      if(n===null)return;
      el.setAttribute('data-count',n);amkCountUp(el,n);
    }).catch(function(){});
})();


/* ═══════════ 20X TICKET BOOST (automatisch, serverseitig) ═══════════ */
window.BOOST={active:false,multiplier:1};
(function(){
  var WD=['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'];
  function fmt(n){return (Math.round(n)||0).toLocaleString('de-DE')}
  function pad(n){return (n<10?'0':'')+n}
  function fmtDur(s){s=Math.max(0,Math.floor(s));var h=Math.floor(s/3600),m=Math.floor(s%3600/60),ss=s%60;
    return h>0?(h+'h '+pad(m)+'m '+pad(ss)+'s'):(pad(m)+'m '+pad(ss)+'s')}
  function weekdayOf(ddmmyyyy){var p=String(ddmmyyyy||'').split('.');if(p.length<3)return '';
    var d=new Date(+p[2],+p[1]-1,+p[0]);return isNaN(d)?'':WD[d.getDay()]}
  var barCd=document.getElementById('boost-bar-cd'),liveCd=document.getElementById('boost-live-cd'),
      bar=document.getElementById('boost-bar'),liveBadge=document.getElementById('boost-live-badge'),
      nextBadge=document.getElementById('boost-next-badge'),nextWhen=document.getElementById('boost-next-when');
  var secLeft=0,cdTimer=null;
  function paintCd(){var t=fmtDur(secLeft);if(barCd)barCd.textContent='endet in '+t;if(liveCd)liveCd.textContent=t;
    if(secLeft<=0){location.reload&&clearInterval(cdTimer)}}
  function startCd(s){secLeft=s;paintCd();if(cdTimer)clearInterval(cdTimer);
    cdTimer=setInterval(function(){secLeft--;if(secLeft<0){secLeft=0;clearInterval(cdTimer)}paintCd()},1000)}
  function renderTicker(d){
    var box=document.getElementById('boost-ticker'),list=document.getElementById('bt-list'),tot=document.getElementById('bt-total');
    if(!box||!list)return;var days=(d.days||[]).filter(function(x){return x.extra>0});
    if(!days.length){box.style.display='none';return}
    box.style.display='block';
    if(tot)tot.textContent=fmt(d.totalExtra||days.reduce(function(a,x){return a+x.extra},0))+' Extra-Punkte vergeben';
    list.innerHTML=days.map(function(x){var wd=weekdayOf(x.day);
      return '<div class="bt-row"><div class="bt-day">'+(wd?wd+' ':'')+x.day+'<small>'+fmt(x.deposits)+' Einzahlungen · x'+(x.mult||20)+' Boost</small></div>'+
             '<div class="bt-extra">+'+fmt(x.extra)+'<small>Extra-Punkte</small></div></div>'}).join('');
  }
  function apply(d){
    // Freigabe je Casino: nur diese Casinos bekommen den Boost.
    var cas=d.casinos||[],scharf=cas.filter(function(c){return c.enabled&&c.multiplier>1});
    window.BOOST={active:!!d.active,multiplier:d.multiplier||1,windowOpen:!!d.window_open,
      casinos:cas,armed:scharf.map(function(c){return c.casino}),
      alle:scharf.length>0&&scharf.length===cas.length,
      multFor:function(name){var c=cas.filter(function(x){return String(x.casino).toLowerCase()===String(name||'').trim().toLowerCase()})[0];
        return (c&&c.enabled&&c.multiplier>1)?c.multiplier:1;}};
    markCasinoOptions();
    if(window.paintPortalBoost)paintPortalBoost();
    if(d.active){
      if(bar)bar.style.display='flex';
      if(liveBadge)liveBadge.style.display='inline-flex';
      if(nextBadge)nextBadge.style.display='none';
      document.body.classList.add('boost-live');
      startCd(d.seconds_left||0);
    }else{
      if(bar)bar.style.display='none';
      if(liveBadge)liveBadge.style.display='none';
      if(nextBadge){nextBadge.style.display='';if(nextWhen)nextWhen.textContent=WD[d.weekday||0]+' '+pad(d.start_hour||16)+':00 Uhr'}
    }
    // Banner-Text: gilt der Boost nicht überall, sagen wir wo.
    var txt=document.querySelector('#boost-bar .bb-txt'),x=document.querySelector('#boost-bar .bb-x');
    if(x&&d.multiplier)x.textContent=d.multiplier+'X';
    if(txt){
      txt.innerHTML=!scharf.length?'<b>TICKET BOOST</b> — aktuell für kein Casino freigeschaltet'
        :window.BOOST.alle?'<b>TICKET BOOST LIVE!</b> Jede Einzahlung jetzt <b>'+d.multiplier+'-fach</b> — aus 100€ = '+fmt(100*d.multiplier)+' Tickets'
        :'<b>TICKET BOOST LIVE bei '+window.BOOST.armed.join(' · ')+'!</b> Dort zählt jede Einzahlung <b>'+d.multiplier+'-fach</b>';
    }
    renderTicker(d);
    // Bildunterschrift der Boost-Szene folgt der Zentrale (Tag, Fenster, Faktor) — stand vorher fest auf „Sonntag 16–22, 20-fach".
    (function(){var wd=WD[d.weekday||0],s=pad(d.start_hour||16),e=pad(d.end_hour||22),x=d.multiplier||20,set=function(id,v){var el=document.getElementById(id);if(el)el.textContent=v};
      set('boost-cap-kick','Diesen '+wd+' · '+s+'–'+e+' Uhr');set('boost-cap-when',wd+' von '+s+' bis '+e+' Uhr');
      set('boost-cap-x',x);set('boost-cap-x2',x);set('boost-cap-x3',x);set('boost-cap-ex',fmt(100*x));})();
    // Deposit-Preview ggf. neu rechnen
    var inp=document.getElementById('dep-amount');if(inp)inp.dispatchEvent(new Event('input'));
  }
  // Casino-Auswahl im Portal mit dem Boost-Faktor beschriften
  function markCasinoOptions(){
    var sel=document.getElementById('dep-casino'),b=window.BOOST;if(!sel||!b)return;
    Array.prototype.forEach.call(sel.options,function(o){
      if(!o.value&&o.disabled)return;
      var name=o.getAttribute('data-casino')||o.value||o.textContent.trim();
      o.setAttribute('data-casino',name); o.value=name;
      var m=b.multFor(name);
      o.textContent=name+(m>1?'   '+(b.windowOpen?'🔥 ':'')+m+'× Boost':'');
    });
  }
  window.markCasinoOptions=markCasinoOptions;
  // Der Status wird oben schon einmal geholt (für die Boost-Szene) — hier
  // nur noch mitbenutzen statt ein zweites Mal zu fragen.
  if(window.BOOST_STATUS_ROH) apply(window.BOOST_STATUS_ROH);
  else beiBoostBanner(function(){ if(window.BOOST_STATUS_ROH) apply(window.BOOST_STATUS_ROH); });
})();

/* ═══════════ DEPOSIT (1€ = 1 Ticket · mit Boost x20) ═══════════ */
function pmsg(id,t,c){var el=document.getElementById(id);if(el){el.textContent=t;el.className='pmsg '+c}}
(function(){var inp=document.getElementById('dep-amount');if(!inp)return;
  function paintPreview(){
    var v=parseInt(inp.value,10)||0,prev=document.getElementById('dep-preview'),tprev=document.getElementById('dep-tickets-preview');
    if(!prev||!tprev)return;
    // Faktor gilt nur für das GEWÄHLTE Casino — nicht mehr pauschal.
    var b=window.BOOST||{},sel=document.getElementById('dep-casino'),cas=sel?sel.value:'';
    var mult=(b.active&&b.multFor)?b.multFor(cas):1,tk=v*mult;
    if(v>=20){prev.style.display='block';prev.classList.toggle('is-boost',mult>1);
      tprev.innerHTML=tk.toLocaleString('de-DE')+' Tickets'+(mult>1?' <span style="color:#34d399">🔥 x'+mult+' BOOST</span>':'')}
    else{prev.style.display='none'}
  }
  inp.addEventListener('input',paintPreview);
  var sel=document.getElementById('dep-casino');if(sel)sel.addEventListener('change',paintPreview);
  window.paintDepositPreview=paintPreview;})();
function doDeposit(e){e.preventDefault();var f=document.getElementById('sf');var sess=getSess();if(!sess){pmsg('s-msg','Bitte anmelden.','err');return}
  if(window.TICKETS_GESPERRT){pmsg('s-msg',window.TICKETS_SPERRTEXT,'err');return}
  var cas=(f.querySelector('[name="casino"]')||{}).value||'';
  var amt=parseInt(document.getElementById('dep-amount').value,10)||0;
  if(!cas){pmsg('s-msg','Bitte Casino auswählen.','err');return}if(amt<20){pmsg('s-msg','Mindesteinzahlung: 20€.','err');return}if(!document.getElementById('tc').checked){pmsg('s-msg','Bitte bestätigen.','err');return}
  pmsg('s-msg','Wird gespeichert…','inf');var btn=f.querySelector('button[type="submit"]');btn.disabled=true;
  fetch(API,{method:'POST',headers:GVH,body:JSON.stringify({action:'deposit',email:sess.email,casino:cas.trim(),amount:amt,name:sess.un||sess.name})})
    .then(function(r){return r.json().catch(function(){return{}})}).then(function(d){btn.disabled=false;if(d&&d.status==='success'){
      var tk=(typeof d.tickets==='number'?d.tickets:amt),boosted=d.boostActive&&d.boostMult>1;
      pmsg('s-msg',amt+'€ eingetragen — '+tk.toLocaleString('de-DE')+' Tickets erhalten'+(boosted?' 🔥 x'+d.boostMult+' BOOST':'')+' ✓','ok');
      popOpen(boosted?'🔥 20X BOOST — Einzahlung erfolgreich!':'Einzahlung erfolgreich!','<span>'+tk.toLocaleString('de-DE')+' Tickets</span> erhalten!',(boosted?'x'+d.boostMult+' Boost aktiv · +'+(d.extraTickets||0).toLocaleString('de-DE')+' Extra · ':'')+'Casino: '+d.casino+' · Gesamt: '+d.totalTickets.toLocaleString('de-DE')+' Tickets');
      document.getElementById('dep-amount').value='';document.getElementById('dep-preview').style.display='none';loadDashboard(sess.email)}else pmsg('s-msg',d&&d.message||'Fehler. Nochmals versuchen.','err')})
    .catch(function(){btn.disabled=false;pmsg('s-msg','Verbindung fehlgeschlagen.','err')})}
function loadStatus(){var sess=getSess();if(!sess)return;var el=document.getElementById('status-info');el.textContent='Wird geladen…';
  fetch(API,{method:'POST',headers:GVH,body:JSON.stringify({action:'check',email:sess.email})})
    .then(function(r){return r.json().catch(function(){return{}})}).then(function(d){if(d&&d.status==='success'&&d.hasDeposits&&d.deposits.length){
      var h='<div style="margin-bottom:16px;font-family:Outfit;font-weight:800;font-size:1.28rem;color:var(--gold)">'+d.totalTickets.toLocaleString('de-DE')+' Tickets · '+d.totalDeposits.toLocaleString('de-DE')+'€</div>';
      h+='<div style="display:flex;flex-direction:column;gap:8px">';
      d.deposits.forEach(function(dep){h+='<div style="display:flex;justify-content:space-between;align-items:center;padding:10px 14px;border-radius:10px;background:rgba(255,255,255,.04);border:1px solid var(--line)"><div><b style="color:var(--text);font-size:1rem">'+dep.casino+'</b><div style="font-size:.82rem;color:var(--muted2)">'+dep.date+'</div></div><div style="text-align:right"><b style="color:var(--gold);font-size:1.04rem">'+dep.amount+'€</b><div style="font-size:.76rem;color:var(--muted2)">'+dep.tickets+' Tickets'+(dep.tickets>dep.amount?' <span style="color:#ff8a3d;font-weight:800">🔥 Boost</span>':'')+' · '+dep.status+'</div></div></div>'});
      h+='</div>';el.innerHTML=h}else el.innerHTML='<div style="font-size:2.4rem;margin-bottom:12px">—</div><div style="font-family:Outfit;font-weight:800;font-size:1.18rem;margin-bottom:6px">Noch keine Einzahlung</div><div style="color:var(--muted);font-size:1rem">Zahle über einen Partner-Link ein und trage es hier ein!</div>'})
    .catch(function(){el.textContent='Verbindung fehlgeschlagen.'})}

/* ═══════════ TABS ═══════════ */
function pPane(name){document.querySelectorAll('.ppane').forEach(function(p){p.classList.remove('on')});document.getElementById('pane-'+name).classList.add('on')}

/* ═══════════ TICKETS SOFORT EINTRAGEN (CTA) ═══════════ */
function goEnterTickets(){var s=getSess();if(s){openPortal(s);setTimeout(function(){try{pPane('deposit')}catch(e){}},60)}else{openAuth('l')}}

/* ═══════════ AUTH ═══════════ */
var SKEY='amk_sess';
function getSess(){return JSON.parse(sessionStorage.getItem(SKEY)||'null')}
function setSess(u){sessionStorage.setItem(SKEY,JSON.stringify(u))}
function clearSess(){sessionStorage.removeItem(SKEY)}
function openAuth(t){document.getElementById('auth-modal').classList.add('on');amTab(t||'l');document.body.style.overflow='hidden'}
function closeAuth(){document.getElementById('auth-modal').classList.remove('on');document.body.style.overflow=''}
function amTab(t){document.getElementById('lform').style.display=t==='l'?'block':'none';document.getElementById('rform').style.display=t==='r'?'block':'none';document.getElementById('amt-l').classList.toggle('on',t==='l');document.getElementById('amt-r').classList.toggle('on',t==='r')}
function fmsg(id,t,c){var el=document.getElementById(id);if(el){el.textContent=t;el.className='amsg '+c}}
function doLogin(e){e.preventDefault();var em=document.getElementById('l-em').value.trim().toLowerCase(),pw=document.getElementById('l-pw').value;
  if(!em||!pw){fmsg('l-msg','Alle Felder ausfüllen.','err');return}
  fmsg('l-msg','Wird geprüft…','inf');
  fetch(API,{method:'POST',headers:GVH,body:JSON.stringify({action:'login',email:em,password:pw})})
    .then(function(r){return r.json().catch(function(){return{}})}).then(function(d){if(d&&d.status==='success'){fmsg('l-msg','Willkommen! ✓','ok');var s={email:em,name:d.name,un:d.username};setSess(s);setTimeout(function(){closeAuth();openPortal(s)},500)}else fmsg('l-msg',d&&d.message||'Login fehlgeschlagen.','err')})
    .catch(function(){fmsg('l-msg','Verbindung fehlgeschlagen.','err')})}
function doReg(e){e.preventDefault();var fn=document.getElementById('r-fn').value.trim(),un=document.getElementById('r-un').value.trim(),em=document.getElementById('r-em').value.trim().toLowerCase(),pw=document.getElementById('r-pw').value;
  if(!fn||!un||!em||!pw){fmsg('r-msg','Alle Felder ausfüllen.','err');return}if(!vEmail(em)){fmsg('r-msg','Ungültige E-Mail.','err');return}if(pw.length<6){fmsg('r-msg','Passwort min. 6 Zeichen.','err');return}if(!document.getElementById('r-terms').checked){fmsg('r-msg','Bitte AGB akzeptieren.','err');return}
  fmsg('r-msg','Wird registriert…','inf');
  fetch(API,{method:'POST',headers:GVH,body:JSON.stringify({action:'register',email:em,password:pw,name:fn,username:un})})
    .then(function(r){return r.json().catch(function(){return{}})}).then(function(d){if(d&&d.status==='success'){var s={email:em,name:fn,un:un};setSess(s);fmsg('r-msg','Account erstellt ✓','ok');setTimeout(function(){closeAuth();openPortal(s)},500)}else fmsg('r-msg',d&&d.message||'Registrierung fehlgeschlagen.','err')})
    .catch(function(){fmsg('r-msg','Verbindung fehlgeschlagen.','err')})}
function paintPortalBoost(){var el=document.getElementById('p-boost');if(!el)return;var b=window.BOOST||{};
  var an=b.active&&Number(b.multiplier)>1;el.style.display=an?'flex':'none';if(!an)return;
  el.innerHTML='🔥&nbsp;<b>'+b.multiplier+'X TICKET-BOOST LÄUFT</b>&nbsp;— '+
    (b.alle?'jede Einzahlung zählt jetzt '+b.multiplier+'-fach!'
          :'nur bei <b>'+(b.armed||[]).join(' · ')+'</b> — dort zählt jede Einzahlung '+b.multiplier+'-fach!');}
function openPortal(s){document.getElementById('portal').classList.add('on');document.body.style.overflow='hidden';
  document.getElementById('pt-name').textContent=s.un||s.name;document.getElementById('pt-email').textContent=s.email;
  document.getElementById('pt-av').textContent=(s.un||s.name||'A').charAt(0).toUpperCase();loadDashboard(s.email);paintPortalBoost()}
function doLogout(){clearSess();document.getElementById('portal').classList.remove('on');document.body.style.overflow=''}
function loadDashboard(email){fetch(API,{method:'POST',headers:GVH,body:JSON.stringify({action:'check',email:email})})
  .then(function(r){return r.json().catch(function(){return{}})}).then(function(d){if(d&&d.status==='success'&&d.hasDeposits){
    document.getElementById('ps-tick').textContent=d.totalTickets.toLocaleString('de-DE');
    document.getElementById('ps-tick-sub').textContent=d.totalDeposits.toLocaleString('de-DE')+'€ eingezahlt';
    document.getElementById('ps-deposits').textContent=d.totalDeposits.toLocaleString('de-DE')+'€';
    document.getElementById('ps-count').textContent=d.depositCount;
    document.getElementById('ps-stat').textContent='✓ Aktiv';document.getElementById('ps-stat').style.color='#34d399';
  }else{document.getElementById('ps-tick').textContent='0';document.getElementById('ps-tick-sub').textContent='Noch keine Einzahlung';
    document.getElementById('ps-deposits').textContent='0€';document.getElementById('ps-count').textContent='0';
    document.getElementById('ps-stat').textContent='Offen';document.getElementById('ps-stat').style.color=''}}).catch(function(){})}
(function(){var s=getSess();if(s)setTimeout(function(){openPortal(s)},1800)})();

/* ═══════════ POPUP ═══════════ */
function popOpen(t,hl,meta){document.getElementById('pop-t').textContent=t;document.getElementById('pop-hl').innerHTML=hl;document.getElementById('pop-meta').textContent=meta;document.getElementById('pop').classList.add('on')}
function popClose(){document.getElementById('pop').classList.remove('on')}
document.addEventListener('keydown',function(e){if(e.key==='Escape'){popClose();closeAuth()}});


/* ═══════════ FLOATING GOLD PARTICLES (desktop only) ═══════════ */
(function(){
  if(window.innerWidth<680)return;
  var c=document.getElementById('particles-canvas');if(!c)return;
  var ctx=c.getContext('2d'),ps=[],N=32;
  function resize(){c.width=window.innerWidth;c.height=window.innerHeight}
  resize();window.addEventListener('resize',resize);
  for(var i=0;i<N;i++)ps.push({x:Math.random()*c.width,y:Math.random()*c.height,r:Math.random()*1.2+.3,
    dx:(Math.random()-.5)*.22,dy:-(Math.random()*.35+.08),o:Math.random()*.35+.08,ph:Math.random()*6.28});
  (function draw(){
    ctx.clearRect(0,0,c.width,c.height);var t=Date.now()*.001;
    for(var i=0;i<ps.length;i++){var p=ps[i];
      p.x+=p.dx+Math.sin(t+p.ph)*.1;p.y+=p.dy;
      if(p.y<-10){p.y=c.height+10;p.x=Math.random()*c.width}
      if(p.x<-10)p.x=c.width+10;if(p.x>c.width+10)p.x=-10;
      var a=p.o*(.5+.5*Math.sin(t*1.2+p.ph));
      ctx.beginPath();ctx.arc(p.x,p.y,p.r,0,6.28);ctx.fillStyle='rgba(255,199,58,'+a+')';ctx.fill();
      ctx.beginPath();ctx.arc(p.x,p.y,p.r*3.5,0,6.28);ctx.fillStyle='rgba(255,199,58,'+(a*.1)+')';ctx.fill();
    }requestAnimationFrame(draw)})();
})();

/* ═══════════ CURSOR GLOW ═══════════ */
(function(){
  if(!window.matchMedia('(hover:hover)').matches)return;
  var g=document.getElementById('cursor-glow');if(!g)return;
  var cx=0,cy=0,tx=0,ty=0;
  document.addEventListener('mousemove',function(e){tx=e.clientX;ty=e.clientY;g.style.opacity='1'});
  document.addEventListener('mouseleave',function(){g.style.opacity='0'});
  (function u(){cx+=(tx-cx)*.065;cy+=(ty-cy)*.065;g.style.left=cx+'px';g.style.top=cy+'px';requestAnimationFrame(u)})();
})();

/* ═══════════ SCROLL PROGRESS ═══════════ */
(function(){
  var b=document.getElementById('scroll-prog');if(!b)return;
  window.addEventListener('scroll',function(){var h=document.documentElement.scrollHeight-window.innerHeight;
    b.style.transform='scaleX('+(h>0?window.scrollY/h:0)+')'},{ passive:true});
})();

/* ═══════════ CASINOS AUS DER ZENTRALE ═══════════
   Die Casinos dieser Seite kommen aus dem Casino-Hub (Kanal "k300"). Vorher
   standen sie an DREI Stellen fest im Liquid — Karten, Partnerliste und das
   Auswahlfeld im Einzahlungsformular. Wer eines tauschen wollte, musste alle
   drei anfassen und vergass zuverlaessig eine.

   SICHERHEITSNETZ, wie auf der Hauptfront: Das feste Markup bleibt stehen.
   Ist der Hub nicht erreichbar, leer oder braucht laenger als vier Sekunden,
   bleibt die Seite exakt so, wie sie heute ist. Es kann also nicht passieren,
   dass hier eine leere Casino-Liste steht.

   Abschalten: window.NK_HUB_OFF = true (z.B. im Theme-Editor).
═══════════════════════════════════════════════════ */
(function () {
  if (window.NK_HUB_OFF) return;

  var HUB = (window.NK_HUB_URL ||
    'https://cbwxgikndyyzdslmfpmo.supabase.co/functions/v1/vertrieb') + '/casinos/k300';

  function esc(v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' }[c];
    });
  }

  /* Der Logo-Zuschnitt kommt als "nk-card__logo--sq" von der Schnittstelle
     (so heisst er auf der Hauptfront). Hier heissen die Klassen cc-logo--sq
     und cc-logo--sqw — deshalb umschreiben statt durchreichen. */
  function logoKlasse(mod) {
    if (!mod) return '';
    if (mod.indexOf('sqw') !== -1) return ' cc-logo--sqw';
    if (mod.indexOf('sq') !== -1) return ' cc-logo--sq';
    return '';
  }

  function karte(c, i) {
    var angebot = c.bonusShort || c.bonus || '';
    return '<div class="cc">' +
      '<div class="cc-rank">' + (i + 1) + '</div>' +
      '<div class="cc-logo">' +
        (c.logo
          ? '<img class="' + esc(logoKlasse(c.logoMod)).trim() + '" src="' + esc(c.logo) + '" alt="' + esc(c.name) + '"/>'
          : '<span class="cc-initials">' + esc(c.initials || c.name.slice(0, 2)) + '</span>') +
      '</div>' +
      '<div class="cc-info">' +
        (angebot ? '<div class="cc-offer">' + esc(angebot) + '</div>' : '') +
        (c.code ? '<div class="cc-code">🎁 100 FS Code: <b>' + esc(c.code) + '</b></div>' : '') +
      '</div>' +
      '<a class="cc-btn" href="' + esc(c.cta) + '" target="_blank" rel="noopener sponsored">Sichern</a>' +
    '</div>';
  }

  function zeichne(liste) {
    var grid = document.getElementById('cc-grid');
    if (grid) grid.innerHTML = liste.map(karte).join('');

    var partner = document.getElementById('p-grid');
    if (partner) {
      partner.innerHTML = liste.map(function (c) {
        return '<a class="p-link" href="' + esc(c.cta) + '" target="_blank" rel="noopener sponsored">' +
          esc(c.name) + '</a>';
      }).join('');
    }

    /* Das Auswahlfeld im Einzahlungsformular. Die bereits getroffene Auswahl
       bleibt erhalten — sonst verliert jemand, der das Formular schon
       ausgefuellt hat, seine Eingabe, sobald die Liste nachlaedt. */
    var sel = document.getElementById('dep-casino');
    if (sel) {
      var vorher = sel.value;
      sel.innerHTML = '<option value="" disabled' + (vorher ? '' : ' selected') +
        '>Casino auswählen...</option>' +
        liste.map(function (c) {
          return '<option' + (c.name === vorher ? ' selected' : '') + '>' + esc(c.name) + '</option>';
        }).join('');
    }
  }

  /* Seite offline geschaltet: keine Casinos, stattdessen der Hinweis aus der
     Zentrale. Die Seite selbst bleibt erreichbar — nur der Casino-Bereich
     macht zu. */
  function offline(text) {
    var grid = document.getElementById('cc-grid');
    var partner = document.getElementById('p-grid');
    var note = document.getElementById('cc-regnote');
    var kasten = document.getElementById('cc-offline');

    if (grid) grid.style.display = 'none';
    if (partner) partner.style.display = 'none';
    if (note) note.style.display = 'none';
    if (kasten) {
      kasten.textContent = text || 'Die Casino-Auswahl ist gerade nicht verfügbar.';
      kasten.style.display = 'block';
    }
  }

  var fertig = false;
  var uhr = setTimeout(function () { fertig = true; }, 4000);

  fetch(HUB, { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (d) {
      if (fertig || !d || !d.ok) return;
      clearTimeout(uhr);

      if (d.online === false) return offline(d.offline_note);

      var liste = (d.casinos || []).filter(function (c) { return c && c.name && c.cta; });
      if (!liste.length) return;                    // leer -> eingebaute Liste bleibt

      liste.sort(function (a, b) { return a.rank - b.rank; });
      zeichne(liste);
    })
    .catch(function () { /* Hub nicht erreichbar -> eingebaute Liste bleibt */ });
})();
